import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from "../../../environments/environment";
import { Router } from '@angular/router';
import { jwtDecode } from 'jwt-decode';

interface loginResponse  {
  token: string
}

@Injectable({
  providedIn: 'root'
})
export class AuthServiceService {
  private tokenKey = "ottoIdCabinets"; 

  constructor(private http:HttpClient, private router: Router) { }

  login(loginData){
    console.log(loginData)
    return this.http.post(`${environment.apiUrl}/api/login`, loginData).subscribe(
    (response: loginResponse)=>{
      localStorage.setItem(this.tokenKey, response.token)
      this.router.navigate(["/dashboard"]);
    } 
    );
  }

  logout(){
    localStorage.removeItem(this.tokenKey)
    this.router.navigate(["/login"]);
  }

  getToken(){
    return localStorage.getItem(this.tokenKey);
  }

  getTokenExpiration(token: string): Date {
    const decodedToken: any = jwtDecode(token);
    if (decodedToken.exp) {
      return new Date(decodedToken.exp * 1000);
    }
    return null;
  }


  isTokenExpired(){
    const token = this.getToken();
    if(token){
      const expire = this.getTokenExpiration(token);
      expire > new Date() ? true : false;  
    }
    return false;
  }


  isLoggedIn(){
    return localStorage.getItem(this.tokenKey);
  }


  readToken(){}
  storeToken(){}
}
